import { apiClient } from '@/lib/api';
/**
 * URL Shortener API client. Routes match the SSLWideWatch backend
 * controllers under /sslwidewatch/links/*. JWT auth + tenant filter
 * applied identically to other customer endpoints.
 */
export const urlShortenerApi = {
    // ---- Links ----
    list: () => apiClient.get('/sslwidewatch/links'),
    get: (id) => apiClient.get(`/sslwidewatch/links/${id}`),
    create: (body) => apiClient.post('/sslwidewatch/links', body),
    update: (id, body) => apiClient.patch(`/sslwidewatch/links/${id}`, body),
    remove: (id) => apiClient.delete(`/sslwidewatch/links/${id}`),
    analytics: (id, days = 30) => apiClient.get(`/sslwidewatch/links/${id}/analytics?days=${days}`),
    // ---- Folders ----
    listFolders: () => apiClient.get('/sslwidewatch/links/folders'),
    createFolder: (body) => apiClient.post('/sslwidewatch/links/folders', body),
    updateFolder: (id, body) => apiClient.patch(`/sslwidewatch/links/folders/${id}`, body),
    removeFolder: (id) => apiClient.delete(`/sslwidewatch/links/folders/${id}`),
    // ---- UTM presets ----
    listPresets: () => apiClient.get('/sslwidewatch/links/utm-presets'),
    createPreset: (body) => apiClient.post('/sslwidewatch/links/utm-presets', body),
    updatePreset: (id, body) => apiClient.patch(`/sslwidewatch/links/utm-presets/${id}`, body),
    removePreset: (id) => apiClient.delete(`/sslwidewatch/links/utm-presets/${id}`),
    // ---- Custom domains ----
    listDomains: () => apiClient.get('/sslwidewatch/links/domains'),
    createDomain: (body) => apiClient.post('/sslwidewatch/links/domains', body),
    removeDomain: (id) => apiClient.delete(`/sslwidewatch/links/domains/${id}`),
};
